// extracted by mini-css-extract-plugin
export default {"Container":"CategoryLeaderSection_Container__Rlt4v","LeadersWrapper":"CategoryLeaderSection_LeadersWrapper__hkReX"};